import { Inventory } from "../opn-snapshot/opn-snapshot.interface"

export interface ToolMatch {
    toolPartNumber: string,
    toolTypeId: number,
    toolType: string,
    parentToolTypeId: ParentToolType,
    parentToolType: string,
    description: string,
    imageUrl?: string,
    toolOpnCount: number,
    multipleBoards: boolean,
    supplierName: string,
    isPartnerResource: boolean,
    partnerFolderUrl: string,
    orderingInfo?: ToolOrderingInfo,
    inventory: Inventory,
    toolGroup: string,
    toolFolderUrl: string,
    displayType: ToolDisplayType
}

export interface ToolOrderingInfo {
    toolOrderableNumber: string,
    available: boolean,
    price: number,
    orderButtonId: number,
    orderButtonName: string,
    orderOnlineUrl?: string,
    currencyExchangeRate: { [currency: string]: number }
}

export interface ExchangeRate {
    currency: string,
    exchangeRate: number
}

export enum ToolDisplayType {
    LoggedOut,
    ViewDetails,
    AddToCart,
    Request,
    MultipleBoards,
    OutOfStock,
    NotAvailable
}

export enum ParentToolType {
    SOFTWARE_DEVELOPMENT = 24,
    DESIGN_TOOLS = 25,
    HARDWARE_DEVELOPMENT = 69,
    REFERENCE_DESIGNS = 114,
    DESIGN_SERVICES = 128
};
